export function getBoxStyles(padding, property) {
  return Object.entries(padding).map(([side, value]) =>
    parseInt(value, 10) > 0 ? `${property}-${side}: ${value};` : ``
  )
}
